import React, { useEffect, useState } from 'react'
import { CCol, CModal, CButton, CModalBody, CModalHeader, CModalTitle } from '@coreui/react';
import CookieFunctions from '../../functions/CookieFunctions';
import { toast } from 'react-toastify';



export default function ResendRequestModal({ visible, closeModal, requestId }) {


    const handleResendEmail = () => {
        resendEmail(requestId);
        closeModal(false);
    };
    function resendEmail(requestId) {
        // create the headers for the fetch 
        const myHeaders = new Headers();
        myHeaders.append('Authorization', 'Bearer ' + CookieFunctions.getJWTToken());

        const formData = new FormData();
        formData.append("requestId", requestId)

        fetch("/api/admin/resendEmail",
            {
                headers: myHeaders,
                method: 'POST',
                body: formData
            }
        ).then((res) => {
            if (res.ok) {
                toast.success("Successfully resent email.", {
                    closeButton: true,
                    autoClose: true,
                    position: toast.POSITION.BOTTOM_CENTER,
                    theme: "colored",

                });
                return res.json()
            } else {
                throw new Error()
            }
        }).then((data) => {
            console.log(data)
        })
    }

    return (
        <CModal alignment='center' visible={visible} onClose={() => closeModal(false)} size='lg'>
            <CModalHeader><CModalTitle id="VerticallyCenteredExample">Resend Approval Email Confirmation</CModalTitle></CModalHeader>
            <CModalBody>
                <CCol>
                    <p>Are you sure you want to resend the email?</p>
                </CCol>
                <CButton color="primary" style={{ marginRight: '5px' }} onClick={handleResendEmail}>Yes</CButton>
                <CButton color="primary" onClick={() => closeModal(false)}>No</CButton>
            </CModalBody>
        </CModal>
    )
}